import { Box, Chip, Grid, useTheme } from "@mui/material";
import {
	EnhancedTextAreaFieldRHF,
	FieldLayout,
	LabelPosition,
} from "@websential/cosmic-v20";
import { FC, JSX, useEffect, useState } from "react";
import { MenuOption, convertMenuHeadTreeDDLData } from "../../ScreenSetup/Panels/ScreenInfoSetupFieldsPanel";
import Select, { GroupBase, OptionProps, components } from "react-select";

import AddIcon from '@mui/icons-material/Add';
import { EnhancedDropDownRHFWithLabel } from "../../../../cosmic/components/EnhancedDropDownRHFWithLabel";
import { RHookFormTextFieldWithLabel } from "../../../../cosmic/components/RHookFormTextFieldWithLabel";

// import { Chip } from "primereact/chip";


interface IMenuHeadsInfoSetupFieldsPanel {
	parentLabelsDDL: any; formMethods: any;
	onAddCategoryClickedHandler: () => void;
	categoryDDL: any
}
export const MenuHeadsInfoSetupFieldsPanel: FC<
	IMenuHeadsInfoSetupFieldsPanel
> = ({ parentLabelsDDL, formMethods, onAddCategoryClickedHandler, categoryDDL }) => {
	const theme = useTheme()
	const [menuHeadDDL, setMenuHeadDDL] = useState<MenuOption[]>([]);
	useEffect(() => {
		if (parentLabelsDDL) {
			const ddl = convertMenuHeadTreeDDLData(parentLabelsDDL)
			setMenuHeadDDL(ddl)
		}
	}, [parentLabelsDDL])

	const customStyles = {
		control: (provided: any, state: { isDisabled: any; }) => {
			return ({
				...provided,
				backgroundColor: state.isDisabled ? 'rgba(0, 0, 0, 0.06)' : '#fff',
				borderColor: '#c3c4c4',
				minHeight: '3em',
				borderRadius: "2px !important",
				marginBottom: "35px",
				// height: '3em',
				// boxShadow: state.isFocused ? null : null,
				":hover": {
					borderColor: '#000'
				},
			})
		},
		container: (provided: any) => ({
			...provided,
			fontFamily: ["Roboto", "sans-serif"].join(","),
			fontSize: ".8125rem",
			fontWeight: 500,
			lineHeight: "1rem",
		}),
	};

	const getItems = (options: any[]) => {
		return options.map((item, index) => ({
			...item,
			value: item.value,
			label: item.label,
		}));
	};


	const Option = (props: JSX.IntrinsicAttributes & OptionProps<unknown, boolean, GroupBase<unknown>> | any) => {

		return (
			<div>
				<components.Option {...props}>
					<label style={{ fontWeight: !props.data.parentId ? "bold" : "normal", marginLeft: props.data.parentId ? "1.5rem" : 0 }}>{props.label}</label>
				</components.Option>
			</div>
		);
	};
	const onHeadSelectionChangeHandler = (selected: any) => {
		formMethods.setValue("menuParentId", selected.value);
	};
	const selectedValue = formMethods.watch("menuParentId");

	const getSingleSelectValue = (options: any[]) => {
		if (!selectedValue) return null;

		return options.find((option) => {
			return option && option.value === selectedValue;
		});
	};
	return (
		<Box>
			<RHookFormTextFieldWithLabel
				label="Label"
				id="name"
				testId={`label`}
				labelPosition={LabelPosition.Top}
			/>
			{/* <EnhancedDropDownRHFWithLabel
				label="Parent"
				selectName="menuParentId"
				testId={`parent`}
				labelPosition={LabelPosition.Top}
				items={parentLabelsDDL ?? []}
			/> */}
			<FieldLayout
				label="Menu Head"
				testId="menu-head"
			>
				<Select
					id="menuParentId"
					{...formMethods.register("menuParentId")}
					value={getSingleSelectValue(menuHeadDDL)}
					onChange={onHeadSelectionChangeHandler}
					options={getItems(menuHeadDDL)}
					styles={customStyles}
					hideSelectedOptions={false}
					components={{
						Option,
						IndicatorSeparator: () => null,
					}}
				/>
			</FieldLayout>
			<RHookFormTextFieldWithLabel
				label="Sequence"
				id="menuOrder"
				testId={`sequence`}
				labelPosition={LabelPosition.Top}
			/>
			<EnhancedDropDownRHFWithLabel
				label={
					<>
						<Grid>Category&nbsp;&nbsp;
							<span
								style={{
									// color: theme.palette.primary.light,
									cursor: "pointer",
									fontSize: ".775rem"
								}}
								onClick={onAddCategoryClickedHandler}
							>
								<Chip
									icon={<AddIcon sx={{ height: "15px" }} />}
									color="primary"
									label="Add"
									sx={{
										fontSize: ".875rem", margin: 0, height: "22px", marginBottom: "2px",
										"& .MuiChip-label": { paddingLeft: "3px", fontSize: ".775rem" }
									}}
								/>
							</span>
						</Grid>
					</>
				}
				items={categoryDDL ?? []}
				selectName="category"
				testId={`category`}
				labelPosition={LabelPosition.Top}
			/>
		</Box>
	);
};
